import React from 'react';
import QuestionRowList from './QuestionRowList';

const ScoringTabContent = props => (
  <div>
    <QuestionRowList {...props} />
  </div>
);

export default ScoringTabContent;



// WEBPACK FOOTER //
// ./src/modules/funnel/components/detail/scoring/ScoringTabContent.js